// Services.
import { WaHelperService } from "../../wa-services/wa-helper-service";

// Classes.
import { EventBaseItem } from "./event-base.item";

export class AthleteResultInfoLiteItem extends EventBaseItem {
  public nameShort: string;
  public date: string;
  public dateToObj: Date;
  public position: number;
  public points: number;
  public inTotal: boolean;

  constructor(
    rawEventParticipantResultItem: any,
    protected waHelperService: WaHelperService
  ) {
    super(rawEventParticipantResultItem, waHelperService);
    this.date = rawEventParticipantResultItem.Date;
    this.dateToObj = new Date(
      new Date(this.date).getTime() +
        Math.abs(new Date(this.date).getTimezoneOffset() * 60000)
    );
    this.position = rawEventParticipantResultItem.Position;
    this.points = rawEventParticipantResultItem.Points;
    this.inTotal = rawEventParticipantResultItem.InTotal;
    this.nameShort = rawEventParticipantResultItem.NameShort;
  }
}
